$( ".menu-item-has-children > .sub-menu " ).hover(
    function() {
      $( this ).parent().addClass( "js-hover" );
    }, function() {
      $( this ).parent().removeClass( "js-hover" );
    }
  );